import React, { useState, useEffect } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col,
    InputGroupText, Input, InputGroup, InputGroupAddon, FormGroup
} from 'reactstrap';
import DivisionCardSmall from '../Division/DivisionCardSmall';
import { sendAccountInvoice, sendInvoices, sendTestInvoice, GetInvoiceList, sendTestAccountInvoice, getDivisions, getFees, getAccounts } from '../../API';
import { getShortDate, getShortUTCDate, getCurrency, getInputDate, sleep, addDaysToDateTime } from '../../Helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faSquare, faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import { faCheckCircle, faCheckSquare, faUsers } from '@fortawesome/free-solid-svg-icons';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';
import LetterConfirmationModal from './LetterConfirmationModal';
import LettersSuccessModal from './LettersSuccessModal';
import Docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
import PizZipUtils from 'pizzip/utils/index.js';
import { saveAs } from 'file-saver'

function DivisionLetters(props) {
    const [divisions, setDivisions] = useState([]);
    const [isLoadingDivisions, setIsLoadingDivisions] = useState(false);
    const [divisionId, setDivisionId] = useState(0);
    const [isSendingEmails, setIsSendingEmails] = useState(false);
    const [templateFile, setTemplateFile] = useState(null);
    const [letterConfirmationModal, setLetterConfirmationModal] = useState(false);
    const [lettersSuccessModal, setLettersSuccessModal] = useState(false);
    const [excludePrevious, setExcludePrevious] = useState(true);
    const [excludeAfter, setExcludeAfter] = useState(true);
    const [excludeDate, setExcludeDate] = useState(new Date(addDaysToDateTime(new Date(), -7).setHours(0, 0, 0, 0)));
    const [MaxDate, setMaxDate] = useState(new Date());
    const [MinDate, setMinDate] = useState(new Date());


    useEffect(() => {
        fetchDivisions();
    }, []);

    const fetchDivisions = async () => {
        try {
            setIsLoadingDivisions(true);
            const divisionsResult = await getDivisions();
            setDivisions(divisionsResult);
        } catch (ex) {
            console.log(ex);
        } finally {
            setIsLoadingDivisions(false);
        }
    };

    const sendEmails = async () => {
        const startTime = new Date();
        console.log(startTime);
        try {
            setIsSendingEmails(true);

            let selectedDivisionIDs = [divisionId]
            if (divisionId == 0) {
                selectedDivisionIDs = [1, 2, 3]
            }

            const accountOptions = {
                divisionIDs: selectedDivisionIDs,
                hasUnpaidFees: true,
                active: 1,
                takeAmount: 0
            };
            if (excludePrevious)
                accountOptions.maxSentInvoiceDate = excludeDate.toUTCString();

            let accounts = await getAccounts(accountOptions);
            let fees = [];
            const accountIDs = accounts.map(a => a.accountID);
            while (accountIDs.length > 0) {
                fees = [...fees, ...await getFees({
                    accountIDs: accountIDs.splice(0, 20),
                    divisionIDs: selectedDivisionIDs,
                    paid: 0,
                    takeAmount: 0
                })];
            }

            const formData = new FormData();

            for (let d of selectedDivisionIDs) {
                formData.append(
                    "DivisionIDs",
                    d
                );
            }


            if (excludePrevious) {
                formData.set(
                    "SentInvoiceMaxDate",
                    excludeDate.toUTCString()
                );
            }

            if (excludeAfter) {
                formData.set(
                    "InvoiceEndDate",
                    MaxDate.toUTCString()
                );
            }


            for (let i = 0; i < accounts.length; i++) {
                const account = accounts[i];
                account.fees = fees.filter(f => f.accountID === account.accountID);
                if (account.fees === null || account.fees.length === 0) {
                    accounts.splice(i, 1);
                    i--;
                    continue;
                }

                account.totalDue = getCurrency(account.fees.map(f => f.currentBalance).reduce((a, b) => a + b, 0));
                account.link = window.env.app.baseUrl + '?linkAccountId=' + account.accountID;

                for (let fee of account.fees) {
                    fee.dueDate = getShortDate(fee.dueDate);
                    fee.currentBalance = getCurrency(fee.currentBalance);
                }

                const generatedDoc = await generateDocument(account);
                account.generatedDoc = generatedDoc;
            }

            console.log(accounts.length);

            let attempts = 0;
            while (accounts.length > 0 && attempts < 5) {
                attempts++;
                const promises = [];
                for (let account of accounts) {
                    try {
                        // Update the formData object
                        formData.set(
                            "InvoiceFile",
                            account.generatedDoc,
                            account.accountNumber
                        );

                        promises.push(sendAccountInvoice(account.accountID, formData));
                        //await sleep(500); //This feels really wrong, but we can't send so many requests at one time. There's probably a better way around it.
                        //Hanlded by resending failed requests. Not waiting at all. Perhaps there's a certain amount of time before trying to resend...
                    } catch (ex) {
                        console.log(ex);
                    }
                }
                console.log("Awaiting promises");
                const results = await Promise.allSettled(promises);
                const rejectedIDs = [];
                for (let i = 0; i < results.length; i++) {
                    if (results[i].status === 'rejected') {
                        rejectedIDs.push(accounts[i].accountID);
                    }
                }
                accounts = accounts.filter(a => rejectedIDs.includes(a.accountID));
            }

            if (accounts.length === 0) {
                toggleLettersSuccessModal();
            } else {
                //accounts should only have those that failed to send 5 times.
                console.log(accounts);
            }
            const endTime = new Date();
            console.log("Start: ", startTime);
            console.log("End: ", endTime);
            console.log("Diff: ", endTime - startTime);
        } catch (ex) {
            console.log(ex);
        } finally {
            setIsSendingEmails(false);
        }
    };

    const sendTestEmail = async () => {
        try {
            setIsSendingEmails(true);

            let selectedDivisionIDs = [divisionId]
            if (divisionId == 0) {
                selectedDivisionIDs = [1, 2, 3]
            }
            console.log(excludeDate);
            console.log(excludeDate.toUTCString());
            const accountOptions = {
                divisionIDs: selectedDivisionIDs,
                hasUnpaidFees: true,
                active: 1,
                takeAmount: 1
            };
            if (excludePrevious)
                accountOptions.maxSentInvoiceDate = excludeDate.toUTCString();

            const accounts = await getAccounts(accountOptions);

            if (accounts.length === 0)
                return;

            const account = accounts[0];
            const fees = await getFees({
                accountIDs: account.accountID,
                divisionIDs: selectedDivisionIDs,
                paid: 0,
                takeAmount: 0
            });

            account.fees = fees;
            if (account.fees === null || account.fees.length === 0)
                return;

            account.totalDue = getCurrency(account.fees.map(f => f.currentBalance).reduce((a, b) => a + b, 0));
            account.link = window.env.app.baseUrl + '?linkAccountId=' + account.accountID;

            for (let fee of account.fees) {
                fee.dueDate = getShortDate(fee.dueDate);
                fee.currentBalance = getCurrency(fee.currentBalance);
            }

            const generatedDoc = await generateDocument(account);

            const formData = new FormData();

            for (let d of selectedDivisionIDs) {
                formData.append(
                    "DivisionIDs",
                    d
                );
            }

            if (excludePrevious) {
                formData.set(
                    "SentInvoiceMaxDate",
                    excludeDate.toUTCString()
                );
            }

            formData.set(
                "InvoiceFile",
                generatedDoc,
                account.accountNumber
            );

            const result = await sendTestAccountInvoice(account.accountID, formData);
            console.log(result);
            toggleLettersSuccessModal();
        } catch (ex) {
            console.log(ex);
        } finally {
            setIsSendingEmails(false);
        }
    };

    const sendInvoiceList = async () => {

        const formData = new FormData();
        let selectedDivisionIDs = [divisionId]
        for (let d of selectedDivisionIDs) {
            formData.append(
                "DivisionIDs",
                d
            );
        }



        if (excludePrevious) {
            formData.set(
                "SentInvoiceMaxDate",
                excludeDate.toUTCString()
            );
        }

        if (excludeAfter) {
            formData.set(
                "InvoiceEndDate",
                MaxDate.toUTCString()
            );
        }

        
        const result = await GetInvoiceList(formData);
    };

    const generateDocument = async (account) => {
        return new Promise(async (resolve, reject) => {
            if (templateFile !== null) {

                var reader = new FileReader();
                reader.readAsBinaryString(templateFile);

                reader.onerror = function (evt) {
                    console.log("error reading file", evt);
                    alert("error reading file" + evt)
                }
                reader.onload = function (evt) {
                    const content = evt.target.result;
                    var zip = new PizZip(content);

                    var doc = new Docxtemplater(zip, { linebreaks: true });
                    doc.setData(account);
                    try {
                        // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
                        doc.render();
                    } catch (error) {
                        // The error thrown here contains additional information when logged with JSON.stringify (it contains a properties object containing all suberrors).
                        function replaceErrors(key, value) {
                            if (value instanceof Error) {
                                return Object.getOwnPropertyNames(value).reduce(function (
                                    error,
                                    key
                                ) {
                                    error[key] = value[key];
                                    return error;
                                },
                                    {});
                            }
                            return value;
                        }
                        console.log(JSON.stringify({ error: error }, replaceErrors));

                        if (error.properties && error.properties.errors instanceof Array) {
                            const errorMessages = error.properties.errors
                                .map(function (error) {
                                    return error.properties.explanation;
                                })
                                .join("\n");
                            console.log("errorMessages", errorMessages);
                            // errorMessages is a humanly readable message looking like this :
                            // 'The tag beginning with "foobar" is unopened'
                        }
                        //throw error;
                        reject(error);
                    }
                    var out = doc.getZip().generate({
                        type: "blob",
                        mimeType:
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    }); //Output the document using Data-URI
                    //saveAs(out, "output.docx");
                    resolve(out);
                }
            }
        });
    };

    const toggleExclude = () => {
        setExcludePrevious(!excludePrevious);
    };

    const toggleExcludeAfter = () => {
        setExcludeAfter(!excludeAfter);
    };

    const updateExcludeDate = (e) => {
        setExcludeDate(new Date(e.target.value + 'T00:00'));
    };

    const updateMaxDate = (e) => {
        setMaxDate(new Date(e.target.value + 'T00:00'));
    };

    const updateMinDate = (e) => {
        setMinDate(new Date(e.target.value + 'T00:00'));
    };

    const updateFile = (e) => {
        if (e.target && e.target.files.length > 0)
            setTemplateFile(e.target.files[0]);
        else
            setTemplateFile(null);
    };

    const acceptLetterConfirmationModal = () => {
        sendEmails();
        setLetterConfirmationModal(false);
    };

    const declineLetterConfirmationModal = () => {
        setLetterConfirmationModal(false);
    };

    const toggleLetterConfirmationModal = () => setLetterConfirmationModal(!letterConfirmationModal);
    const toggleLettersSuccessModal = () => setLettersSuccessModal(!lettersSuccessModal);

    return (
        <div id="multipleLetters">
            <div className="division-list tooltip-parent">
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText><FontAwesomeIcon icon={faUsers} /></InputGroupText>
                    </InputGroupAddon>
                    <Input type="select" value={divisionId} onChange={e => setDivisionId(+e.target.value)}>
                        <option value={0}>Environmental Fees</option>
                        {divisions.filter(d => ![1, 2, 3].includes(d.divisionID)).map(d => (<option key={d.divisionID} value={d.divisionID}>{d.divisionName}</option>))}
                    </Input>
                </InputGroup>
                <div className="tooltip-target tooltip-top">
                    DANR Program
                </div>
            </div>
            <div className="template-selector tooltip-parent">
                <div className="exclude-check">
                    <div onClick={toggleExclude} className="action-icon">
                        <FontAwesomeIcon icon={excludePrevious ? faCheckCircle : faCircle} />
                    </div>
                    <span>Exclude Previous Sent Letters</span>
                </div>
                <div className="tooltip-target tooltip-top">
                    Exclude
                </div>
            </div>
            {excludePrevious ?
                <div className="template-selector tooltip-parent">
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText><FontAwesomeIcon icon={faCalendarAlt} /></InputGroupText>
                        </InputGroupAddon>
                        <Input type="date" onChange={updateExcludeDate} value={getInputDate(excludeDate)} />
                    </InputGroup>
                    <div className="tooltip-target tooltip-top">
                        Exclude Since Date
                    </div>
                </div>
            : null}
            <div className="template-selector tooltip-parent">
                <Input type="file" onChange={updateFile} />
                <div className="tooltip-target tooltip-top">
                    Template File
                </div>
            </div>
            <div className="template-selector tooltip-parent">
                <div className="exclude-check">
                    <div onClick={toggleExcludeAfter} className="action-icon">
                        <FontAwesomeIcon icon={excludeAfter ? faCheckCircle : faCircle} />
                    </div>
                    <span>Exclude Fees due after</span>
                </div>
                <div className="tooltip-target tooltip-top">
                    Exclude
                </div>
            </div>
            {excludeAfter ?
            <div >
                <div className="template-selector tooltip-parent">
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText><FontAwesomeIcon icon={faCalendarAlt} /></InputGroupText>
                        </InputGroupAddon>
                        <Input type="date" onChange={updateMaxDate} value={getInputDate(MaxDate)} />
                    </InputGroup>
                    <div className="tooltip-target tooltip-top">
                        Exclude fees due after
                    </div>
                    </div>
                </div>
                   : null }
            
            <div className="actions">
                <Button onClick={sendTestEmail} disabled={isSendingEmails || templateFile === null}>Test Letter</Button>
                <Button onClick={toggleLetterConfirmationModal} color="danr-green" disabled={isSendingEmails || templateFile === null}>Send Letters</Button>
                <Button onClick={sendInvoiceList} disabled={isSendingEmails}>Invoice List</Button>
            </div>
            {isSendingEmails ? (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>) : null}
            <LetterConfirmationModal open={letterConfirmationModal} toggle={toggleLetterConfirmationModal} accept={acceptLetterConfirmationModal} decline={declineLetterConfirmationModal} />
            <LettersSuccessModal open={lettersSuccessModal} toggle={toggleLettersSuccessModal} />
        </div>
    );
}

export default DivisionLetters;